<template>
  <div>
    <Header></Header>
    <div class="col-12 d-inline-flex">
      <div class="col-10 ms-3 overflow-visible me-3 pt-3">
        <div class="stripe-configuration">
          <h2>{{ editMode ? 'Edit' : 'Create' }} League</h2>
          <form @submit.prevent="saveChanges">
            <div v-for="field in fields" :key="field.name" class="form-group">
              <label v-if="field.name !== 'leagueId' || editMode" :for="field.name">{{ field.label }}:</label>
              <input v-if="((field.name !== 'leagueId') || (field.name === 'leagueId' && editMode)) && (field.name !== 'status') && (field.name !== 'active') && (field.name !== 'application')"
                     :id="field.name" v-model="editedConfig[field.name]" :style="{ minWidth: '500px', width: editedConfig[field.name] ? `${editedConfig[field.name].length * 10}px` : '100px' }"
                     type="text" class="form-control" :disabled="(field.name === 'leagueId') && editMode">
              <select v-else-if="field.name === 'application'" :id="field.name" v-model="editedConfig[field.name]" class="form-select" style="max-width: 500px;">
                <option v-for="app in applicationList" :key="app" :value="app">{{ app }}</option>
              </select>
              <input class="checkbox" v-else-if="field.name === 'active' || field.name === 'status'"
                     type="checkbox" :id="field.name" v-model="editedConfig[field.name]">
            </div>

            <div v-if="error != ''" class="error-message">{{error}}</div>
            <br>
            <a role="button" class="procricket-btn" @click="saveChanges">{{ editMode ? 'Save Changes' : 'Create League' }}</a>
            <a role="button" class="ms-3 procricket-btn--reverse " @click="cancelEdit"> Cancel </a>
          </form>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import Header from '@/components/Header.vue'
import { League } from '@/model/models'
import AdminService from "@/services/admin-service";

export default defineComponent({
  name: 'LeagueEdit',
  components: {
    Header,
  },
  data () {
    return {
      editedConfig: {
        leagueId : this.$route.params.leagueId,
        caption : this.$route.params.caption,
        description : this.$route.params.description,
        logoFilename : this.$route.params.logoFilename,
        logoAltText : this.$route.params.logoAltText,
        application : this.$route.params.application,
        status : this.$route.params.status === 'true' || this.$route.params.status === true,
        active : this.$route.params.active === 'true' || this.$route.params.active === true
      },
      editMode: false,
      applicationList: [],
      fields: [
        { name: "leagueId", label: "League Id" },
        { name: "caption", label: "Caption" },
        { name: "description", label: "Description" },
        { name: "logoFilename", label: "Logo Filename" },
        { name: "logoAltText", label: "Logo Alt Text" },
        { name: "application", label: "Application" },
        { name: "status", label: "Status" },
        { name: "active", label: "Active" },
      ],
      error: ""
    }
  },
  created() {
    if (this.$route.params.leagueId) {
      this.editMode = true;
    }
    const storedApps = localStorage.getItem('applicationList');
    if (storedApps) {
      this.applicationList = JSON.parse(storedApps);
    } else {
      AdminService.getApplications().then(() => {
        this.applicationList = JSON.parse(localStorage.getItem('applicationList'));
      });
    }
  },
  methods: {
    saveChanges() {
      const dataToSave = new League(
          this.editedConfig.leagueId ? Number(this.editedConfig.leagueId) : null,
          this.editedConfig.caption,
          this.editedConfig.description,
          this.editedConfig.logoFilename,
          this.editedConfig.logoAltText,
          this.editedConfig.application,
          this.editedConfig.status,
          this.editedConfig.active
      );

      if (this.editMode) {
        AdminService.updateLeague(dataToSave).then(() => {
          alert('Update complete');
          this.$router.push({ name: 'Leagues' });
        }).catch((error) => {
          console.error("Error updating League:", error);
          if (error.response && error.response.data && error.response.data.message) {
            this.error = error.response.data.message;
            alert(error.response.data.message);
          } else {
            this.error = error.message;
          }
        });
      } else {
        AdminService.insertLeague(dataToSave).then(() => {
          alert('Insert complete');
          this.$router.push({ name: 'Leagues' });
        }).catch((error) => {
          if (error.response && error.response.data && error.response.data.message) {
            this.error = error.response.data.message;
          } else {
            this.error = error.message;
          }
        });
      }
    },
    cancelEdit() {
      this.$router.back();
    }

  }
})
</script>
<style src="../../assets/style.css">
</style>
